import { render, staticRenderFns } from "./ScreeningQuestionsMenu.vue?vue&type=template&id=469ca174"
import script from "./ScreeningQuestionsMenu.vue?vue&type=script&lang=ts"
export * from "./ScreeningQuestionsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports